<script>
import { Link, useNavigate } from "svelte-navigator";
import { Past, Replay, StartingSoon, Live, Future } from './events';
import { markdown } from './util';

const navigate = useNavigate();

export let id;
export let state;
export let title;
export let description;
export let startTime;
export let endTime;
export let speakers;
export let stream;

let live;
let dateString;
let startTimeString;
let endTimeString;
let activeStream;
let isExternalShow;

$: live = state === StartingSoon || state === Live;
$: activeStream = state === Replay ? stream.replay : stream.live;
$: isExternalShow = activeStream?.type === 'zoom';

$: dateString = startTime.toLocaleString('default', {month: 'short', day: 'numeric'})
$: startTimeString = startTime.toLocaleTimeString('default', {hour: 'numeric', minute: '2-digit', hour12: true})
$: endTimeString = endTime.toLocaleTimeString('default', {hour: 'numeric', minute: '2-digit', hour12: true})

function joinShow(e) {
  if (isExternalShow) {
    window.open(activeStream.url, "_blank");
  } else {
    navigate(`/show/${id}`);
  }
}
</script>

<div class="card" class:live>
  <div class="left">
    <div class="month">{dateString}</div>
    <div class="startTime">{startTimeString} - </div>
    <div class="endTime">{endTimeString}</div>

    {#if state === Past}

      <div class="action-box past">
        Live session ended
      </div>

    {:else if state !== Future}

      <div on:click={joinShow} class="action-box" class:live>
        <div>{state === StartingSoon ? "STARTING SOON" : state === Live ? "LIVE" : ""}</div>
        <div class="button" class:live class:past={state === Replay}>
          {state === Replay ? "REPLAY" : "JOIN"}
        </div>
      </div>

    {/if}

  </div>
  <div class="right">
    <div class="title mb-16">{title}</div>
    <div class="desc mb-16">{@html markdown(description)}</div>

    {#if speakers}
      <div class="speaker-container">
        {#each speakers as speaker (speaker.id)}
          <div class="speaker row vcenter nowrap">
            <img src={speaker.imageUrl} /> {speaker.firstName} {speaker.surname}
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
@import './util';
@import './theme';
.card {
  @include shadow;
  display: flex;
  flex-direction: row;
  padding: 24px;
  background-color: white;
  color: black;
  border-left: 16px solid $event-card-inactive-color;
  margin-bottom: 16px;
  font-size: 20px;

  @include landscape {
    flex-direction: column;
  }

  &.live {
    border-left-color: $event-card-active-color;
  }
}

.action-box {
  margin: 16px 0;
  cursor: pointer;
  &.live {
    color: $event-card-active-color;
    font-weight: 700;
    font-size: 20px;
  }

  &.past {
    color: $event-card-inactive-color;
    font-style: italic;
    font-size: 14px;
  }
}

.left {
  width: 180px;
  @include landscape {
    width: unset;
  }
}

.right {
  flex: 1;
}

.month {
  font-size: 16px;
  opacity: .7;
}

.startTime {
  font-weight: bold;
}

.endTime {
}

.title {
  font-weight: 700;
  font-size: 20px;
}

.desc {
  font-size: 16px;
  font-weight: 350;
}

 .speaker-container {
  display: inline-flex;
  flex-wrap: wrap;
  margin: -12px 0 0 -12px;
  width: calc(100% + 12px);

  > * {
    margin: 12px 0 0 12px;
  }

  .speaker {
    font-weight: 300;

    img {
      border-radius: 100%;
      height: 52px;
      width: 52px;
      margin-right: 10px;
    }
  }
}

.past {
  background-color: $event-card-inactive-color;
}
</style>